import { addFieldEditor } from "aldoo-ra/CMS/field-editor-resolver"
import StoreTemplateSelectorEditor from "./field-editors/store-template-selector"
import StripeKeyEditor from "./field-editors/stripe-key-editor"

// Register the custom store template selector field editor
addFieldEditor("StoreTemplateSelector", StoreTemplateSelectorEditor)
addFieldEditor("StripeKeyEditor", StripeKeyEditor)

/**
 * Store Settings Content Type
 * Local-only content type for managing store configuration via ParamIO
 */

// This content type is registered locally for UI purposes only
// Data is stored in ParamIO, not in the CMS database
const StoreSettingsContentType = {
  type: "StoreSettings",
  label: "",
  description: "Configuration settings for the store and Stripe integration",
  localOnly: true, // This indicates it's not stored in CMS database

  // Groups definition (separate from fields)
  groups: [
    {
      id: "stripe_integration",
      label: "Stripe Integration",
      description: "Stripe API keys and webhook configuration",
      expanded: true
    },
    {
      id: "settings",
      label: "Settings",
      description: "General store settings",
      expanded: true
    }
  ],

  // Fields as flat array with group assignments
  fields: [
    {
      id: "STRIPE_PUBLISHABLE_KEY",
      label: "Stripe Publishable Key",
      description: "Stripe publishable key for client-side integration",
      type: "Text",
      editor: "StripeKeyEditor",
      group: "stripe_integration",
      required: false
    },
    {
      id: "STRIPE_WEBHOOK_SECRET",
      label: "Stripe Webhook Secret",
      description: "Secret used to verify Stripe webhook signatures",
      type: "Text",
      editor: "StripeKeyEditor",
      group: "stripe_integration",
      required: false
    },
    {
      id: "STRIPE_SECRET_KEY",
      label: "Stripe Secret Key",
      description: "Stripe secret key for server-side API calls",
      type: "Text",
      editor: "StripeKeyEditor",
      group: "stripe_integration",
      required: false
    },
    {
      id: "PURCHASE_CONFIRMATION_PLATFORMS",
      label: "Purchase Confirmation Platforms",
      description: "Platforms that should receive purchase confirmation notifications",
      type: "Array",
      item: {
        labelField: "name",
        fields: [
          {
            id: "name",
            label: "Platform",
            type: "Text",
            required: true
          }
        ]
      },
      group: "settings",
      required: false
    }
  ]
}

export default StoreSettingsContentType
